(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ac-size-suggestion"] && !Shopify.designMode) return;
  try {
    function createACSizeEngine() {
  'use strict';

  const LETTERS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL', '5XL', '6XL'];
  const SIZE_NAMES = /^(size|sizes|taglia|taglie|taille|talla|gr[oö]sse|gr[oö]ße)(\s*\([^)]*\))?$/i;
  const WORD_SIZES = { 'EXTRA EXTRA SMALL': 'XXS', 'EXTRA SMALL': 'XS', SMALL: 'S', MEDIUM: 'M', LARGE: 'L', 'EXTRA LARGE': 'XL', 'EXTRA EXTRA LARGE': 'XXL' };
  const ISSUE = Object.freeze({ ambiguous: 'ambiguous_chart', missing: 'chart_unavailable' });
  const clean = value => String(value == null ? '' : value).replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  const uniq = items => [...new Set(items)];
  const numeric = value => value !== '' && value != null && Number.isFinite(Number(value)) ? Number(value) : null;

  const PROFILE_PRIOR = { version: 'ANSUR-II-pooled-adults-6066-2026-09-30', hull: [[0.9960499093303989,0.08879514695581121,-206.92164734626382],[-0.9388763158866085,-0.3442546491584236,151.18412355950096],[0.9714568788813216,-0.23721621461055573,-171.14698043742777],[0.7284116862935501,-0.6851397049295762,-93.37732978500736],[-0.9223971544960524,0.386242785534676,107.09048600356041],[-0.754605522163505,0.6561787149247864,46.58212697251068],[0.9684929325968499,0.24904103981061748,-220.89386806668935],[0.9701425001453317,0.24253562503633397,-220.34361534550857],[0.6385724695973152,-0.7695616941300978,-71.92782055625759],[0.27786530268078424,-0.9606200464107109,-6.7060806049845425],[-0.9993019805449086,0.037357083384856916,141.61416562239822],[-0.9966846158226081,0.08136200945490507,138.66323866376138],[-0.2893895012763195,0.9572114272986104,-82.75649307268259],[-0.6060432152628558,0.7954317200324988,-0.5189245030689165]], dimensions: { chest: [96.07069745453784,-0.1936984862526237,0.6596125135360038], waist: [84.23590587119956,-0.46691257710100403,0.8154010997667221], hip: [97.49168122876947,-0.38727655931202903,0.5259308562316742] }, lower: { chest: -8.106792254881606, waist: -7.591910783088018, hip: -6.505547626674385 }, upperWaist: 8.784851833303511 };

  function profilePrior(height, weight) {
    if (PROFILE_PRIOR.hull.some(([a, b, c]) => a * height + b * weight + c > 1e-7)) return null;
    const result = {};
    for (const [key, [intercept, heightSlope, weightSlope]] of Object.entries(PROFILE_PRIOR.dimensions)) result[key] = intercept + heightSlope * (height - 170) + weightSlope * (weight - 70);
    return result;
  }

  function sizeAliases(value) {
    const text = clean(value).toUpperCase().replace(/\s+/g, ' ');
    const result = [text];
    const simple = WORD_SIZES[text] || text.replace(/^2XL$/, 'XXL').replace(/^3XL$/, 'XXXL').replace(/^XXXXL$/, '4XL').replace(/^XXXXXL$/, '5XL');
    if (LETTERS.includes(simple)) return uniq([text, simple]);

    const paired = simple.match(/^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL)\s*[/\-]\s*(\d{2,3})$/);
    if (paired) return uniq([...result, ...sizeAliases(paired[1]), paired[2]]);
    if (/^\d{2,3}(?:\.5)?$/.test(simple)) return result;
    return [];
  }

  function headerInfo(value) {
    const text = clean(value).toLowerCase().replace(/[（]/g, '(').replace(/[）]/g, ')');
    const bare = text.replace(/\([^)]*\)/g, '').replace(/[:*]/g, '').trim();
    if (/^(size|sizes|taglia|taglie|taille|talla|gr[oö]sse|gr[oö]ße)$/.test(bare)) return { key: 'size' };
    if (/^(spec|specs|specification|specifications|model|recommended height|height\/chest)\b/.test(bare)) return { key: null };
    if (/shoulder.*(?:sleeve|cuff)|sleeve.*shoulder|hood(?:ie)?\s+length/i.test(text)) return { key: null };
    let key = null;
    if (/\b(chest|bust|torace|petto|pit[ -]to[ -]pit)\b/.test(text)) key = 'chest';
    else if (/\b(waist|waistline|vita)\b/.test(text)) key = 'waist';
    else if (/\b(hips?|seat|fianchi)\b/.test(text)) key = 'hip';
    else if (/\b(thigh|coscia)\b/.test(text)) key = 'thigh';
    else if (/\b(hem|bottom width)\b/.test(text)) key = 'hem';
    else if (/\b(shoulders?|spalle)\b/.test(text)) key = 'shoulder';
    else if (/\b(inseam|inside leg)\b/.test(text)) key = 'inseam';
    else if (/\b(sleeve|sleeves|manica)\b/.test(text)) key = 'sleeve';
    else if (/\b(length|lenght|outseam|lunghezza)\b/.test(text)) key = 'length';
    if (!key) return { key: null };
    return {
      key,
      text,
      flat: /\b(width|half|flat|pit[ -]to[ -]pit|1\/2)\b/.test(text),
      circumference: /\b(circumference|circum|girth)\b/.test(text),
      inch: /\b(inches|inch)\b|(?:\(|\b)in\.?\s*\)?\s*$|[″"]/i.test(text),
      cm: /\bcm\b|centimet/i.test(text)
    };
  }

  function numberCell(value, isInches) {
    let text = clean(value).toLowerCase().replace(/,/g, '.').replace(/[–—~～]/g, '-');

    text = text.replace(/\s*(cm|centimeters?|centimetres?|inches|inch|in|[″"])\s*$/i, '').trim();
    const match = text.match(/^(\d{1,3}(?:\.\d{1,2})?)(?:\s*-\s*(\d{1,3}(?:\.\d{1,2})?))?$/);
    if (!match) return null;
    const factor = isInches ? 2.54 : 1;
    const min = Number(match[1]) * factor;
    const max = Number(match[2] || match[1]) * factor;
    if (!(min > 0 && max >= min && max <= 350)) return null;
    return { min, max, ranged: min !== max };
  }

  function resolveSize(label, sizes) {
    const aliases = sizeAliases(label);
    if (!aliases.length) return null;
    const direct = sizes.filter(size => clean(size.label).toUpperCase() === clean(label).toUpperCase());
    if (direct.length === 1) return direct[0];
    const matches = sizes.filter(size => size.aliases.some(alias => aliases.includes(alias)));
    return matches.length === 1 ? matches[0] : null;
  }

  function detectCategory(product, settings) {
    const title = clean(product.title).toLowerCase();
    const type = clean(product.type).toLowerCase();
    const tags = (Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',')).join(' ').toLowerCase();
    const description = clean(String(product.description || '').replace(/<br\b[^>]*>|<\/(?:p|li|div|section|h[1-6]|tr)>/gi, '\n').replace(/<[^>]*>/g, ' ').split(/[\r\n]+/).filter(line => !/\bmodels?\b|\b(?:wearing|wears)\b.*\bsize\b/i.test(line)).join(' ')).toLowerCase();
    const explicit = ['tops', 'bottoms', 'outerwear', 'knitwear'].includes(settings.category) ? settings.category : null;
    function classify(text) {
      const footwear = /\b(sneakers?|shoes?|boots?|sandals?|loafers?|slippers?|footwear)\b/.test(text);
      const accessory = /\b(sunglasses|eyewear|glasses|necklaces?|bracelets?|earrings?|keychains?|belts?|scarves|scarf|beanies?|hats?|caps?|bags?|backpacks?|wallets?|socks?|gloves?|rings?|accessories)\b/.test(text);
      const clothing = /\b(pants|trousers?|jeans|joggers?|sweatpants|shorts|skirts?|hoodies?|sweatshirts?|jackets?|coats?|puffers?|parkas?|shirts?|tees?|t-shirts?|sweaters?|cardigans?|knitwear|vests?|henleys?|tank|tops?|polos?|blazers?)\b/.test(text);
      if (footwear || (accessory && !clothing)) return { category: 'unsupported', subtype: footwear ? 'footwear' : 'accessory' };
      let category = null;
      if (/\b(pants|trousers?|jeans|joggers?|sweatpants|shorts|skirts?)\b/.test(text)) category = 'bottoms';
      else if (/\b(jackets?|coats?|puffers?|parkas?|blazers?|windbreakers?|outerwear)\b/.test(text)) category = 'outerwear';
      else if (/\b(hoodies?|sweatshirts?|sweaters?|cardigans?|knitwear|pullovers?)\b/.test(text)) category = 'knitwear';
      else if (/\b(shirts?|tees?|t-shirts?|vests?|henleys?|tank|tops?|polos?)\b/.test(text)) category = 'tops';
      const subtype = /\bshorts\b/.test(text) ? 'shorts' : /\bskirts?\b/.test(text) ? 'skirt' : /\b(hoodies?|sweatshirts?)\b/.test(text) ? 'sweatshirt' : category;
      return category ? { category, subtype } : null;
    }
    const detected = classify(title) || classify(type) || classify(tags) || { category: 'unsupported', subtype: 'unknown' };
    if (detected.category === 'unsupported' && ['footwear', 'accessory'].includes(detected.subtype)) return detected;
    const category = explicit || detected.category;
    const subtype = detected.subtype || category;
    function detectFit(text) {
      if (/\b(slim|fitted|body[ -]hugging|tight[ -]fit|skinny)\b/.test(text)) return 'slim';
      if (/\b(oversized|oversize|loose[ -]fit|loose fitting|relaxed[ -]fit|relaxed silhouette)\b/.test(text)) return 'oversized';
      if (/\b(regular[ -]fit|regular fitting)\b/.test(text)) return 'regular';
      return null;
    }
    const fit = ['slim', 'regular', 'oversized'].includes(settings.fit) ? settings.fit : detectFit(title) || detectFit(type) || detectFit(description) || detectFit(tags) || 'regular';
    const cropped = /\b(cropped|crop[ -]fit)\b/.test(title + ' ' + type + ' ' + description);
    return { category, subtype, fit, cropped };
  }

  function flatWaistHipFactor(row, header) {
    if (!row.hip) return null;
    if (header && header.flat && header.circumference) return null;
    const factor = header && header.flat ? 2 : header && header.circumference ? 1 : row.hip.min >= 40 && row.hip.max <= 80 ? 2 : row.hip.min >= 80 && row.hip.max <= 190 ? 1 : null;
    return factor && row.hip.min * factor >= row.waist.max * 2 && row.hip.max * factor <= row.waist.min * 2 * 1.9 ? factor : null;
  }

  function measurementCell(text, column, tableInches) {
    const cm = /(?:\bcm|centimeters?|centimetres?)\s*$/i.test(clean(text));
    const inch = /(?:\bin|inches|inch|[″"])\s*$/i.test(clean(text));
    const conflict = (column.cm && column.inch) || (column.cm && inch) || (column.inch && cm);
    return { conflict, value: conflict ? null : numberCell(text, inch || (!cm && (column.inch || (!column.cm && tableInches)))) };
  }

  function chartMode(rows, key, header, settings, detected, headers) {
    const setting = settings[key === 'chest' ? 'chestMode' : 'waistMode'];
    if (setting === 'flat') return { factor: 2, source: 'manual' };
    if (setting === 'circumference') return { factor: 1, source: 'manual' };
    if (header.flat && header.circumference) return null;
    if (header.flat) return { factor: 2, source: 'header' };
    if (header.circumference) return { factor: 1, source: 'header' };
    const values = rows.map(row => row[key].min);
    if (key === 'waist') {
      if (Math.min(...values) >= 58 && Math.max(...values) <= 170) return { factor: 1, source: 'circumference' };
      const hipHeader = (headers || []).find(col => col.key === 'hip');
      const hipFactors = rows.filter(row => row.hip).map(row => flatWaistHipFactor(row, hipHeader));
      const minLength = detected.subtype === 'shorts' ? 20 : 80;
      const maxLength = detected.subtype === 'shorts' ? 85 : 140;
      const coherent = rows.length >= 2 && rows.every(row => row.waist.min >= 28 && row.waist.max <= 55 && !row.waist.ranged && row.length && !row.length.ranged && row.length.min >= minLength && row.length.max <= maxLength && (row.hip ? flatWaistHipFactor(row, hipHeader) != null : row.thigh && !row.thigh.ranged && row.thigh.min >= 25 && row.thigh.max <= 85));
      return coherent && new Set(hipFactors).size <= 1 ? { factor: 2, source: 'inferred_flat', hipFactor: hipFactors[0] || null } : null;
    }

    const coherentFlat = rows.length >= 2 && rows.every(row => !row.chest.ranged && row.chest.min >= 35 && row.chest.max <= 90 && row.shoulder && !row.shoulder.ranged && row.shoulder.min >= 32 && row.shoulder.max <= 90 && row.chest.min >= row.shoulder.min * 0.82 && row.chest.min <= row.shoulder.min * 1.65 && row.length && !row.length.ranged && row.length.min >= (detected.cropped ? 25 : 35) && row.length.max <= 140);
    if (coherentFlat) return { factor: 2, source: 'inferred_flat' };
    if (detected.fit === 'slim' && Math.min(...values) >= 72 && Math.max(...values) <= 150) return { factor: 1, source: 'circumference' };
    if (Math.min(...values) >= 90 && Math.max(...values) <= 200) return { factor: 1, source: 'circumference' };
    if (Math.min(...values) >= 70 && Math.max(...values) <= 150 && rows.every(row => row.shoulder && row.shoulder.min >= 20 && row.shoulder.max <= 60 && row.chest.min >= row.shoulder.max * 1.75)) return { factor: 1, source: 'circumference' };
    return null;
  }

  function readChart(table, sizes, settings, detected) {
    const key = detected.category === 'bottoms' ? 'waist' : 'chest';
    const tableRows = Array.from(table.querySelectorAll('tr')).filter(row => row.closest('table') === table).map(row => Array.from(row.children).filter(cell => /^(TD|TH)$/.test(cell.tagName)).map(cell => ({ text: clean(cell.textContent), span: Number(cell.getAttribute('colspan') || 1), rowSpan: Number(cell.getAttribute('rowspan') || 1) })));
    const tableText = clean(table.textContent).toLowerCase();
    const precedingText = clean(table.previousElementSibling ? table.previousElementSibling.textContent : '').toLowerCase();
    const hasInches = text => /\b(inches|inch)\b|\(in\.?\)/i.test(text);
    const hasCm = text => /\bcm\b|centimet/i.test(text);
    const emptyCell = text => /^(?:[-–—/]|n\/?a)?$/i.test(clean(text));
    const tableInches = !hasCm(tableText) && (hasInches(tableText) || (hasInches(precedingText) && !hasCm(precedingText)));
    let header = null;
    let rawRows = [];
    let malformed = false;
    let unknownMeasuredSizes = false;
    let headerIndex = -1;
    for (let index = 0; index < tableRows.length; index += 1) {
      const row = tableRows[index];
      const info = row.map(cell => headerInfo(cell.text));
      if (info.some(col => col.key === 'size') && info.some(col => ['chest', 'waist', 'length', 'hip'].includes(col.key))) {
        if (row.some(cell => cell.span !== 1 || cell.rowSpan !== 1)) continue;
        header = info;
        headerIndex = index;
        break;
      }
    }
    if (header) {
      const sizeIndex = header.findIndex(col => col.key === 'size');
      const primaryIndex = header.findIndex(col => col.key === key);
      const keys = header.map(col => col.key).filter(Boolean);
      if (new Set(keys).size !== keys.length) return { issue: 'ambiguous_chart' };
      for (const cells of tableRows.slice(headerIndex + 1)) {
        const mapped = cells[sizeIndex] && resolveSize(cells[sizeIndex].text, sizes);
        if (!mapped) {
          if (cells[sizeIndex] && sizeAliases(cells[sizeIndex].text).length && primaryIndex >= 0 && cells[primaryIndex] && !emptyCell(cells[primaryIndex].text)) unknownMeasuredSizes = true;
          continue;
        }
        if (cells.length !== header.length || cells.some(cell => cell.span !== 1 || cell.rowSpan !== 1)) { malformed = true; continue; }
        const row = { label: mapped.label };
        header.forEach((col, index) => {
          if (col.key && col.key !== 'size') {
            const parsed = measurementCell(cells[index].text, col, tableInches);
            row[col.key] = parsed.value;
            if (parsed.conflict) malformed = true;
            if (col.key === key && !row[col.key] && !emptyCell(cells[index].text)) malformed = true;
          }
        });
        rawRows.push(row);
      }
    } else {
      for (let index = 0; index < tableRows.length; index += 1) {
        const cells = tableRows[index];
        if (!cells.length || headerInfo(cells[0].text).key !== 'size') continue;
        const labels = cells.slice(1).map(cell => cell.text);
        const mapped = labels.map(label => resolveSize(label, sizes));
        if (!mapped.some(Boolean) || cells.some(cell => cell.span !== 1 || cell.rowSpan !== 1)) continue;
        header = [{ key: 'size' }];
        const transposed = mapped.map(size => size ? { label: size.label } : null);
        for (const values of tableRows.slice(index + 1)) {
          if (!values.length) continue;
          const info = headerInfo(values[0].text);
          if (!info.key || info.key === 'size') continue;
          if (header.some(col => col.key === info.key)) { malformed = true; continue; }
          header.push(info);
          if (values.length !== cells.length || values.some(cell => cell.span !== 1 || cell.rowSpan !== 1)) { malformed = true; continue; }
          values.slice(1).forEach((cell, valueIndex) => {
            if (!transposed[valueIndex]) {
              if (info.key === key && sizeAliases(labels[valueIndex]).length && !emptyCell(cell.text)) unknownMeasuredSizes = true;
              return;
            }
            const parsed = measurementCell(cell.text, info, tableInches);
            const value = parsed.value;
            if (parsed.conflict) malformed = true;
            if (info.key === key && !value && !emptyCell(cell.text)) malformed = true;
            transposed[valueIndex][info.key] = value;
          });
        }
        rawRows = transposed.filter(Boolean);
        break;
      }
    }
    if (!header || !rawRows.length) return null;
    const keyHeader = header.find(col => col.key === key);
    if (!keyHeader) return null;
    if (malformed) return { issue: 'ambiguous_chart' };
    const rows = [];
    for (const row of rawRows) {
      const duplicates = rawRows.filter(item => item.label === row.label);
      if (duplicates.some(item => JSON.stringify(item) !== JSON.stringify(row))) return { issue: 'conflicting_chart' };
      if (row[key] && !rows.some(item => item.label === row.label)) rows.push(row);
    }
    const missingSizes = sizes.filter(size => !rows.some(row => row.label === size.label)).map(size => size.label);
    const partial = missingSizes.length > 0;
    const sizeLabelMismatch = partial && unknownMeasuredSizes;
    if (!rows.length || (partial && (rows.length < 2 || (sizeLabelMismatch && !['tops', 'knitwear'].includes(detected.category))))) return { issue: 'incomplete_chart' };
    const mode = chartMode(rows, key, keyHeader, settings, detected, header);
    if (!mode) return { issue: 'ambiguous_measurement_units' };
    const hipHeader = header.find(col => col.key === 'hip');
    const hips = rows.map(row => row.hip).filter(Boolean);
    const hipFactor = hipHeader && !(hipHeader.flat && hipHeader.circumference) ? hipHeader.flat ? 2 : hipHeader.circumference ? 1 : mode.hipFactor || (hips.length && hips.every(value => value.min >= 85 && value.max <= 180) ? 1 : null) : null;
    const notes = [];
    if (partial) notes.push('incomplete_chart');
    if (sizeLabelMismatch) notes.push('size_label_mismatch');
    if (mode.source === 'inferred_flat') notes.push('inferred_flat_measurement');
    if (hipFactor === 2 && hipHeader && !hipHeader.flat) notes.push('inferred_hip_measurement');
    for (const row of rows) {
      row[key] = { ...row[key], min: row[key].min * mode.factor, max: row[key].max * mode.factor };
      if (row.hip) row.hip = hipFactor == null ? null : { ...row.hip, min: row.hip.min * hipFactor, max: row.hip.max * hipFactor };
      if (row.hip && (row.hip.min < 60 || row.hip.max > 230)) row.hip = null;
      if (row[key].min < (key === 'waist' ? 50 : 65) || row[key].max > (key === 'waist' ? 190 : 220)) return { issue: 'implausible_chart' };
      if (row.length && (row.length.min < 15 || row.length.max > 160)) return { issue: 'implausible_chart' };
      if (detected.subtype === 'shorts' && row.length && row.length.min > 85) return { issue: 'conflicting_product_chart' };
    }
    const ordered = sizes.map(size => rows.find(row => row.label === size.label)).filter(Boolean);
    const ranked = ordered.every(row => sizes.find(size => size.label === row.label).rank != null);
    if (ranked) {
      ordered.sort((a, b) => sizes.find(size => size.label === a.label).rank - sizes.find(size => size.label === b.label).rank);
      for (let index = 1; index < ordered.length; index += 1) {
        if (ordered[index][key].min + 1 < ordered[index - 1][key].min) return { issue: 'nonmonotonic_chart' };
      }
    }
    const lengthHeader = header.find(col => col.key === 'length');
    const lengthComparable = !!lengthHeader && /^(?:(?:body|garment|clothing|total)\s+)?(?:length|lenght)(?:\s*\((?:cm|in|inch|inches)\))?$|^outseam(?:\s*\((?:cm|in|inch|inches)\))?$/i.test(lengthHeader.text || '') && rows.every(row => row.length && !row.length.ranged);
    return { key, rows: ordered, mode: mode.source, ranged: rows.some(row => row[key].ranged), assumedCm: !tableInches && !header.some(col => col.cm || col.inch), partial, missingSizes, notes, lengthComparable, sizeLabelMismatch };
  }

  function analyse(product, settings) {
    product = product || {};
    settings = Object.assign({ category: 'auto', chestMode: 'auto', waistMode: 'auto', fit: 'auto', allowEstimate: true }, settings || {});
    const detected = detectCategory(product, settings);
    const options = (product.options || []).map((option, index) => typeof option === 'string' ? { name: option, values: uniq((product.variants || []).map(variant => (variant.options || [])[index]).filter(Boolean)) } : { name: option.name, values: (option.values || []).map(value => typeof value === 'object' ? value.name : value) });
    let sizeOptionIndex = options.findIndex(option => SIZE_NAMES.test(clean(option.name)));
    if (sizeOptionIndex < 0) {
      const possible = options.map((option, index) => ({ option, index })).filter(({ option }) => option.values.length > 1 && option.values.every(value => sizeAliases(value).length));
      if (possible.length === 1) sizeOptionIndex = possible[0].index;
    }
    const sizeOption = options[sizeOptionIndex];
    const labels = sizeOption ? uniq(sizeOption.values.map(clean).filter(Boolean)) : [];
    const sizes = labels.map(label => {
      const aliases = sizeAliases(label);
      const letter = aliases.find(alias => LETTERS.includes(alias));
      const numericLabel = aliases.find(alias => /^\d{2,3}(?:\.5)?$/.test(alias));
      return { label, aliases, rank: letter ? LETTERS.indexOf(letter) : numericLabel ? Number(numericLabel) + 100 : null, letterRank: letter ? LETTERS.indexOf(letter) : null };
    });
    const supported = detected.category !== 'unsupported' && sizes.length > 0 && sizes.every(size => size.aliases.length > 0);
    const result = {
      ...detected, supported, settings, sizes, sizeOptionIndex,
      measurement: detected.category === 'bottoms' ? 'waist' : 'chest',
      chart: null, chartIssues: [],
      options, variants: product.variants || [], selectedOptions: product.selectedOptions || []
    };
    if (!supported) return result;
    const pieces = options.filter((option, index) => index !== sizeOptionIndex).flatMap(option => option.values);
    if ((pieces.some(value => /\b(top|jacket|hoodie)\b/i.test(value)) && pieces.some(value => /\b(bottom|pants|trousers|shorts|skirt)\b/i.test(value))) || /\b(separates|two[ -]piece|tracksuit set)\b/i.test(product.title || '')) { result.supported = false; result.chartIssues.push('conflicting_product_chart'); return result; }
    if (typeof DOMParser === 'undefined') { result.chartIssues.push(ISSUE.missing); return result; }
    const doc = new DOMParser().parseFromString(String(product.description || ''), 'text/html');
    const candidates = [];
    for (const table of Array.from(doc.querySelectorAll('table'))) {
      const candidate = readChart(table, sizes, settings, detected);
      if (candidate && candidate.issue) result.chartIssues.push(candidate.issue);
      else if (candidate) candidates.push(candidate);
    }
    if (candidates.length > 1) {

      const reference = candidates[0];
      const same = candidates.every(chart => chart.rows.length === reference.rows.length && chart.rows.every(row => {
        const previous = reference.rows.find(item => item.label === row.label);
        return previous && (!(chart.lengthComparable && reference.lengthComparable) || (Math.abs(row.length.min - previous.length.min) <= 1 && Math.abs(row.length.max - previous.length.max) <= 1)) && Math.abs(row[chart.key].min - previous[chart.key].min) <= 1 && Math.abs(row[chart.key].max - previous[chart.key].max) <= 1 && ((!row.hip && !previous.hip) || (row.hip && previous.hip && Math.abs(row.hip.min - previous.hip.min) <= 1 && Math.abs(row.hip.max - previous.hip.max) <= 1));
      }));
      if (!same) result.chartIssues.push('conflicting_chart');
      else result.chart = candidates.find(chart => chart.mode !== 'inferred_flat' && !chart.assumedCm) || reference;
    } else if (candidates.length === 1) result.chart = candidates[0];

    if (result.chartIssues.some(issue => ['conflicting_chart', 'conflicting_product_chart', 'nonmonotonic_chart'].includes(issue))) result.chart = null;
    if (!result.chart && !result.chartIssues.length) result.chartIssues.push(ISSUE.missing);
    result.chartIssues = uniq(result.chartIssues);
    return result;
  }

  function availability(analysis, label) {
    const selected = Array.isArray(analysis.selectedOptions) ? analysis.selectedOptions : analysis.options.map(option => analysis.selectedOptions[option.name]);
    const matches = analysis.variants.filter(variant => {
      const values = variant.options || [];
      return clean(values[analysis.sizeOptionIndex]) === label && values.every((value, index) => index === analysis.sizeOptionIndex || !selected[index] || clean(value) === clean(selected[index]));
    });
    const available = matches.find(variant => variant.available === true);
    return { available: available ? true : analysis.variants.length ? false : null, variantId: (available || matches[0] || {}).id || null };
  }

  function successful(analysis, label, method, notes, extra) {
    const stock = availability(analysis, label);
    const result = Object.assign({ status: 'ok', size: label, method, notes: uniq([...notes, ...(stock.available === false ? ['size_unavailable'] : [])]), ...stock }, extra || {});
    if (analysis.chart?.sizeLabelMismatch) {
      result.conditional = true;
      result.confidence = 'low';
      result.notes = uniq([...result.notes, 'size_label_mismatch']);
    }
    return result;
  }

  function isCompactTopChart(analysis) {
    const rows = analysis.chart?.rows || [];
    return ['tops', 'knitwear'].includes(analysis.category) && rows.length >= 2 && rows.every(row => row.chest && !row.chest.ranged && row.chest.min >= 65 && row.chest.max <= 100 && row.shoulder && !row.shoulder.ranged && row.shoulder.min >= 20 && row.shoulder.max <= 46 && row.length && !row.length.ranged && row.length.min >= 35 && row.length.max <= 75);
  }

  function easeFor(analysis, preference) {

    if (analysis.category === 'bottoms') return { target: preference === 'relaxed' ? 3 : 2, min: 0, max: preference === 'relaxed' ? 7 : 6 };
    const outer = analysis.category === 'outerwear';
    const warm = outer || analysis.category === 'knitwear' || analysis.subtype === 'sweatshirt';
    let values;
    if (analysis.fit === 'slim') values = outer ? { target: 10, min: 6, max: 20 } : { target: 3, min: 0, max: 10 };
    else if (analysis.fit === 'oversized') values = outer ? { target: 26, min: 14, max: 48 } : { target: 22, min: 12, max: 45 };
    else values = warm ? { target: 16, min: 8, max: 30 } : { target: 10, min: 4, max: 22 };
    if (preference === 'relaxed') return { target: values.target + 4, min: values.min + 2, max: values.max + 4 };
    return values;
  }

  function recommend(analysis, profile) {
    if (!analysis || !analysis.supported) return { status: 'unsupported', size: null, method: null, notes: ['unsupported_product'] };
    profile = profile || {};
    const height = numeric(profile.heightCm);
    const weight = numeric(profile.weightKg);
    const body = numeric(profile[analysis.measurement === 'waist' ? 'waistCm' : 'chestCm']);
    const preference = profile.fitPreference === 'relaxed' || profile.fit === 'relaxed' ? 'relaxed' : 'intended';
    const providedInvalid = ['heightCm', 'weightKg', analysis.measurement === 'waist' ? 'waistCm' : 'chestCm'].some(key => profile[key] != null && profile[key] !== '' && numeric(profile[key]) == null);
    if (providedInvalid || (height != null && (height < 100 || height > 230)) || (weight != null && (weight < 25 || weight > 250)) || (body != null && (body < 40 || body > 200))) return { status: 'need_measurement', size: null, method: null, notes: ['invalid_measurements'], measurement: analysis.measurement };
    const notes = [...(analysis.chart?.notes || [])];
    if (analysis.cropped) notes.push('cropped_length');
    if (height != null && (height > 185 || height < 160)) notes.push('check_length');
    if (body != null && analysis.chart) {
      const chart = analysis.chart;
      const ease = easeFor(analysis, preference);
      if (chart.ranged) notes.push('range_uses_minimum');
      if (chart.mode === 'inferred_flat') notes.push('inferred_flat_measurement');
      const minimum = chart.key === 'waist' ? -1 : isCompactTopChart(analysis) ? 0 : Math.max(0, ease.min - 2);
      const maximum = chart.key === 'waist' ? 10 : ease.max + 8;
      const matches = chart.rows.map(row => ({ row, ease: row[chart.key].min - body })).filter(item => item.ease >= minimum && item.ease <= maximum).sort((a, b) => Math.abs(a.ease - ease.target) - Math.abs(b.ease - ease.target) || a.row[chart.key].min - b.row[chart.key].min);
      if (!matches.length) return { status: 'no_match', size: null, method: chart.mode === 'inferred_flat' ? 'estimate' : 'measurements', notes: uniq([...notes, 'outside_chart_range']), measurement: analysis.measurement };
      const best = matches[0];
      if (best.ease < ease.min) notes.push(chart.key === 'waist' ? 'waist_close_fit' : 'closer_fit');
      if (best.ease > ease.max) notes.push(chart.key === 'waist' ? 'waist_roomier_fit' : 'roomier_fit');
      if (chart.key === 'waist') notes.push('hips_unverified');
      return successful(analysis, best.row.label, chart.mode === 'inferred_flat' ? 'estimate' : 'measurements', notes, { measurement: analysis.measurement, garmentMeasurementCm: best.row[chart.key].min, bodyMeasurementCm: body, easeCm: best.ease, chartRow: best.row });
    }
    if (!analysis.chart) return { status: 'need_measurement', size: null, method: null, notes: uniq([...notes, 'chart_unavailable']), measurement: analysis.measurement };
    if (!analysis.settings.allowEstimate) return { status: 'need_measurement', size: null, method: null, notes: uniq([...notes, ...(analysis.chart ? ['body_measurement_needed'] : ['chart_unavailable'])]), measurement: analysis.measurement };
    if (height == null || weight == null) return { status: 'need_measurement', size: null, method: null, notes: ['height_weight_needed'], measurement: analysis.measurement };
    const prior = profilePrior(height, weight);
    if (analysis.category === 'bottoms') {
      if (!prior) return { status: 'need_measurement', size: null, method: 'estimate', notes: uniq([...notes, 'profile_outside_evidence', 'check_waist']), measurement: analysis.measurement };
      const chart = analysis.chart;
      const target = prior.waist + easeFor(analysis, preference).target;
      const plausible = chart.rows.filter(row => row.waist.min >= prior.waist + PROFILE_PRIOR.lower.waist && row.waist.min <= prior.waist + PROFILE_PRIOR.upperWaist + 6 && (!row.hip || row.hip.min >= prior.hip + PROFILE_PRIOR.lower.hip));
      const matches = plausible.map(row => ({ row, distance: Math.abs(row.waist.min - target) })).sort((a, b) => a.distance - b.distance || b.row.waist.min - a.row.waist.min);
      notes.push('height_weight_estimate', 'profile_chart_estimate', 'profile_waist_position', 'check_waist', 'hips_unverified');
      if (chart.ranged) notes.push('range_uses_minimum');
      if (!matches.length) return { status: 'no_match', size: null, method: 'estimate', notes: uniq([...notes, 'outside_chart_range']), measurement: analysis.measurement };
      const row = matches[0].row;
      if (row.waist.min < prior.waist + 1) notes.push('waist_close_fit');
      else if (row.waist.min > prior.waist + 6) notes.push('waist_roomier_fit');
      return successful(analysis, row.label, 'estimate', notes, { measurement: analysis.measurement, garmentMeasurementCm: row.waist.min, chartRow: row });
    }
    if (!prior && !(height >= 150 && height <= 200 && profilePrior(175, weight))) return { status: 'need_measurement', size: null, method: 'estimate', notes: uniq([...notes, 'profile_outside_evidence', 'check_chest']), measurement: analysis.measurement };
    const chart = analysis.chart;
    const ease = easeFor(analysis, preference);
    const chestCoefficients = PROFILE_PRIOR.dimensions.chest;
    const rankingChest = chestCoefficients[0] + chestCoefficients[1] * 5 + chestCoefficients[2] * (weight - 70);
    const targetChest = rankingChest + ease.target;
    const minimumRoom = -2;
    const generousRoom = analysis.fit === 'oversized' ? 80 : analysis.category === 'outerwear' || analysis.category === 'knitwear' ? 52 : 44;
    const maximumRoom = Math.max(ease.max + 12, generousRoom);
    const eligible = chart.rows.filter(row => analysis.sizes.some(size => size.label === row.label) && row.chest && row.chest.min >= rankingChest + minimumRoom && row.chest.min <= rankingChest + maximumRoom);
    notes.push('height_weight_estimate', 'profile_chart_estimate', 'check_chest');
    if (chart.ranged) notes.push('range_uses_minimum');
    if (chart.mode === 'inferred_flat') notes.push('inferred_flat_measurement');
    if (!eligible.length) {
      if (preference === 'intended' && isCompactTopChart(analysis)) {
        const maximumGap = Math.min(12, rankingChest * 0.15);
        const comparisons = chart.rows.filter(row => analysis.sizes.some(size => size.label === row.label) && rankingChest - row.chest.min > 2 && rankingChest - row.chest.min <= maximumGap).sort((a, b) => b.chest.min - a.chest.min || b.length.min - a.length.min);
        if (comparisons.length) {
          const row = comparisons[0];
          if (row.length.min < 58 && height >= 170) notes.push('check_length');
          return successful(analysis, row.label, 'estimate', [...notes, 'fitted_comparison', 'closer_fit'], { conditional: true, confidence: 'low', measurement: analysis.measurement, garmentMeasurementCm: row.chest.min, chartRow: row });
        }
      }
      return { status: 'no_match', size: null, method: 'estimate', notes: uniq([...notes, 'outside_chart_range']), measurement: analysis.measurement };
    }
    const lengths = chart.rows.map(row => row.length && !row.length.ranged && Number.isFinite(row.length.min) && row.length.min >= 45 && row.length.min <= 95 ? row.length.min : null);
    const orderedLengths = lengths.filter(value => value != null).sort((a, b) => a - b);
    const middleLength = orderedLengths.length ? orderedLengths[Math.floor(orderedLengths.length / 2)] : null;
    const compareLength = chart.lengthComparable === true && !analysis.cropped && lengths.every(value => value != null) && middleLength >= 62 && middleLength <= 85 && Math.max(...lengths) - Math.min(...lengths) <= 16 && lengths.every((value, index) => index === 0 || value >= lengths[index - 1]);
    const neckHip = 58.550583363611594 + 0.33951023652666856 * (height - 170) + 0.04877748155048275 * (weight - 70);
    const hemAllowance = analysis.subtype === 'sweatshirt' ? 8 : analysis.category === 'outerwear' || analysis.category === 'knitwear' ? 6 : 10;
    const targetLength = neckHip + hemAllowance;
    const thresholds = [45, 55, 65, 75, 85, 95, 105, 115, 125, 135];
    let rank = thresholds.findIndex(limit => weight < limit);
    if (rank === -1) rank = LETTERS.length;
    rank += analysis.fit === 'oversized' ? 0 : 1;
    if (!analysis.cropped && height > 185 && rank < LETTERS.indexOf('L')) rank += 1;
    if (preference === 'relaxed') rank += 1;
    const ranked = eligible.map(row => {
      const room = row.chest.min - rankingChest;
      const letterRank = analysis.sizes.find(size => size.label === row.label)?.letterRank;
      const nominalScore = letterRank == null ? 0 : Math.abs(letterRank - rank);
      const widthScore = Math.abs(row.chest.min - targetChest) * 0.02;
      const difference = compareLength ? row.length.min - targetLength : 0;
      const lengthScore = compareLength ? Math.max(0, Math.abs(difference) - 2) * (difference < 0 ? 0.12 : 0.06) : 0;
      return { row, room, score: nominalScore + widthScore + lengthScore };
    }).sort((a, b) => a.score - b.score || Math.abs(a.row.chest.min - targetChest) - Math.abs(b.row.chest.min - targetChest) || a.row.chest.min - b.row.chest.min);
    const best = ranked[0];
    const nominal = analysis.sizes.find(size => size.letterRank === rank);
    if (!nominal || !eligible.some(row => row.label === nominal.label)) notes.push('closest_available_chart_size');
    if (best.room < ease.min) notes.push('closer_fit');
    if (best.room > ease.max) notes.push('roomier_fit');
    if (compareLength && Math.abs(best.row.length.min - targetLength) > 4) notes.push('check_length');
    return successful(analysis, best.row.label, 'estimate', notes, { measurement: analysis.measurement, garmentMeasurementCm: best.row.chest.min, chartRow: best.row });

  }

  return { analyse, recommend };
}


function enhanceSizeGuide(Type, engine, brand) {
  const proto = Type.prototype;
  const bodyKey = `${brand}_size_profile_v1`;
  const garmentKey = `${brand}_size_garment_profile_v1`;
  const contextKey = `${brand}_size_link_context_v1`;
  const eventName = `${brand}:size-profile-change`;
  const read = key => { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } };
  const valid = record => {
    if (record?.version !== 1) return false;
    const ranges = { heightCm: [120, 230], weightKg: [30, 250], chestCm: [40, 230], waistCm: [40, 200], hipCm: [40, 240], lengthCm: [10, 170], footLengthCm: [15, 36] };
    return Object.entries(ranges).every(([key, [min, max]]) => record[key] == null || Number.isFinite(record[key]) && record[key] >= min && record[key] <= max);
  };
  const copy = (host, key, fallback) => host.copy?.[key] || fallback;
  const primaryGuide = (owner, dialog) => [...dialog.querySelectorAll('cz-size-suggestion,idlt-size-suggestion,ac-size-suggestion')].find(host => host.closest('dialog-component.popup-link') === owner);
  const relevant = (host, profile) => {
    const result = { ...profile };
    const key = ['footLength', 'insole'].includes(host.analysis.measurement) ? 'footLengthCm' : host.analysis.measurement === 'waist' || host.analysis.category === 'bottoms' ? 'waistCm' : 'chestCm';
    if (brand === 'cz' && result.measurementSource === 'profile') {
      for (const field of ['chestCm', 'waistCm', 'hipCm', 'lengthCm', 'footLengthCm']) result[field] = null;
    } else {
      for (const field of ['chestCm', 'waistCm', 'footLengthCm']) if (field !== key) result[field] = null;
      if (key !== 'waistCm') result.hipCm = null;
      if (result.measurementSource !== 'garment') result.lengthCm = null;
      if (brand === 'cz') { result.heightCm = null; result.weightKg = null; }
    }
    return result;
  };
  proto.sizeGuideSuggestion = function() {
    if (!this.analysis?.supported || !this.config?.product?.id) return null;
    const id = String(this.config.product.id);
    if (this.smartConfirmed?.productId === id) {
      const profile = relevant(this, this.smartConfirmed.profile);
      return { profile, result: engine.recommend(this.analysis, profile) };
    }
    const body = read(bodyKey), garments = read(garmentKey), context = read(contextKey);
    const garment = brand === 'cz' ? garments?.products?.[id] : garments?.productId === id ? garments : null;
    const candidates = [];
    if (valid(garment) && (context?.source === 'garment' && context.productId === id || !context && !valid(body))) candidates.push({ ...garment, measurementSource: 'garment' });
    if (valid(body)) {
      const key = ['footLength', 'insole'].includes(this.analysis.measurement) ? 'footLengthCm' : this.analysis.measurement === 'waist' || this.analysis.category === 'bottoms' ? 'waistCm' : 'chestCm';
      if (brand === 'cz') {
        if (Number.isFinite(body[key]) && body.measurementSource !== 'profile') candidates.push({ ...body, measurementSource: 'body' });
        const fit = ['intended', 'close', 'regular', 'relaxed'].includes(context?.profileFitPreference) ? context.profileFitPreference : 'intended';
        if (Number.isFinite(body.heightCm) && Number.isFinite(body.weightKg)) candidates.push({ ...body, measurementSource: 'profile', fitPreference: fit });
      } else candidates.push({ ...body, measurementSource: 'body' });
    }
    if (!candidates.length && valid(garment)) candidates.push({ ...garment, measurementSource: 'garment' });
    for (const candidate of candidates) {
      const profile = relevant(this, candidate);
      const result = engine.recommend(this.analysis, profile);
      if (result.status === 'ok' && result.size) return { profile, result };
    }
    return null;
  };
  proto.refreshSizeGuideLink = function() {
    const owner = this.closest('dialog-component.popup-link');
    const button = owner?.querySelector(':scope > button.popup-link__button');
    const dialog = owner?.querySelector(':scope > dialog');
    if (!button || !dialog?.contains(this)) return;
    if (this.smartOwner !== owner) this.bindSizeGuideLink(owner, dialog);
    this.smartButton = button;
    if (primaryGuide(owner, dialog) !== this) return;
    const match = this.sizeGuideSuggestion();
    const result = match?.result;
    const ok = result?.status === 'ok' && result.size;
    const conditional = brand === 'ac' && ok && result.conditional === true;
    const label = conditional ? copy(this, 'link_conditional', 'Closest size: {size}').replace('{size}', result.size) : ok ? copy(this, 'link_suggested', 'Suggested size: {size}').replace('{size}', result.size) : copy(this, 'link_label', 'Size guide');
    let hint = ok ? copy(this, 'link_view', 'View size guide') : copy(this, 'link_hint', 'Find your fit');
    if (conditional) hint = copy(this, 'link_compare', 'Check measurements · View guide');
    else if (ok && result.available === false) hint = copy(this, 'link_unavailable', 'Currently unavailable · View guide');
    else if (ok && result.notes?.some(note => ['waist_close_fit', 'closer_fit'].includes(note))) hint = copy(this, 'link_snug', 'May fit snug · View guide');
    if (button.getAttribute('type') !== 'button') button.setAttribute('type', 'button');
    if (button.getAttribute('aria-haspopup') !== 'dialog') button.setAttribute('aria-haspopup', 'dialog');
    const aria = `${label}. ${hint}`;
    if (button.getAttribute('aria-label') !== aria) button.setAttribute('aria-label', aria);
    if (!button.hasAttribute('data-size-guide-link')) button.setAttribute('data-size-guide-link', '');
    if (button.dataset.sizeGuideState !== (ok ? 'suggested' : 'empty')) button.dataset.sizeGuideState = ok ? 'suggested' : 'empty';
    const currentLabel = button.querySelector('[data-size-guide-label]');
    const currentHint = button.querySelector('[data-size-guide-hint]');
    if (currentLabel && currentHint && button.querySelector('[data-size-guide-icon]')) {
      if (currentLabel.textContent !== label) currentLabel.textContent = label;
      if (currentHint.textContent !== hint) currentHint.textContent = hint;
    } else {
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('data-size-guide-icon', ''); icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('aria-hidden', 'true');
      const outline = document.createElementNS(icon.namespaceURI, 'rect');
      for (const [key, value] of Object.entries({ x: '3', y: '7', width: '18', height: '10', rx: '2' })) outline.setAttribute(key, value);
      const ticks = document.createElementNS(icon.namespaceURI, 'path'); ticks.setAttribute('d', 'M7 7v5m5-5v3m5-3v5'); icon.append(outline, ticks);
      const content = document.createElement('span'); content.className = 'smart-size-link__copy';
      const main = document.createElement('span'); main.setAttribute('data-size-guide-label', ''); main.textContent = label;
      const sub = document.createElement('span'); sub.setAttribute('data-size-guide-hint', ''); sub.textContent = hint;
      content.append(main, sub);
      const arrow = document.createElementNS(icon.namespaceURI, 'svg'); arrow.setAttribute('viewBox', '0 0 24 24'); arrow.setAttribute('aria-hidden', 'true'); arrow.classList.add('smart-size-link__arrow');
      const path = document.createElementNS(icon.namespaceURI, 'path'); path.setAttribute('d', 'm9 5 7 7-7 7'); arrow.append(path);
      button.replaceChildren(icon, content, arrow);
    }
  };
  proto.bindSizeGuideLink = function(owner, dialog) {
    this.smartAbort?.abort(); this.smartObserver?.disconnect();
    this.smartOwner = owner;
    this.smartAbort = new AbortController();
    const signal = this.smartAbort.signal;
    const queue = () => {
      if (this.smartQueued) return;
      this.smartQueued = true;
      queueMicrotask(() => { this.smartQueued = false; if (this.isConnected) this.refreshSizeGuideLink(); });
    };
    this.smartObserver = new MutationObserver(changes => {
      if (changes.some(change => change.target === owner || change.target === this.smartButton || this.smartButton?.contains(change.target))) queue();
    });
    this.smartObserver.observe(owner, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-size-guide-link', 'data-size-guide-state', 'aria-label', 'type'] });
    const memoryChanged = event => {
      if (event.type === 'storage' && event.key !== null && ![bodyKey, garmentKey, contextKey].includes(event.key)) return;
      if (event.detail?.source === this) return;
      this.smartConfirmed = null;
      this.lastProfile = null;
      this.lastResult = null;
      if (brand === 'cz') this.sourceProfiles = this.readMemory().profiles;
      const resultNode = this.querySelector(`[data-${brand}-result]`);
      const entry = this.querySelector(`[data-${brand}-entry]`);
      const forgetButton = this.querySelector(`[data-${brand}-forget]`);
      if (resultNode) resultNode.hidden = true;
      if (entry) entry.hidden = brand === 'cz' ? !this.canCalculate : !this.analysis?.supported;
      if (forgetButton) forgetButton.hidden = !valid(read(bodyKey)) && !read(garmentKey);
      queue();
    };
    window.addEventListener('storage', memoryChanged, { signal });
    document.addEventListener(eventName, memoryChanged, { signal });
    owner.addEventListener('dialog:open', () => {
      if (primaryGuide(owner, dialog) !== this) return;
      const match = this.sizeGuideSuggestion();
      if (!match) return;
      const record = read(bodyKey);
      if (record?.unit && valid(record)) this.setUnits(record.unit, false);
      const displayProfile = { ...match.profile };
      if (brand === 'cz' && match.profile.measurementSource !== 'profile') {
        displayProfile.heightCm = record?.heightCm ?? null;
        displayProfile.weightKg = record?.weightKg ?? null;
      }
      this.setProfile(displayProfile);
      if (brand === 'cz') this.activeSource = match.profile.measurementSource;
      this.refreshCategory();
      this.lastProfile = match.profile;
      this.renderResult(match.result, false);
    }, { signal });
  };
  const init = proto.init;
  proto.init = function(...args) {
    this.smartConfirmed = null;
    const value = init.apply(this, args);
    this.refreshSizeGuideLink();
    return value;
  };
  const render = proto.renderResult;
  proto.renderResult = function(result, ...args) {
    const value = render.call(this, result, ...args);
    if (this.lastProfile && this.config?.product?.id) this.smartConfirmed = { productId: String(this.config.product.id), profile: { ...this.lastProfile } };
    this.refreshSizeGuideLink();
    return value;
  };
  const save = proto.saveMemory;
  proto.saveMemory = function(profile, ...args) {
    const value = save.call(this, profile, ...args);
    if (this.querySelector(`[data-${brand}-remember]`)?.checked && read(bodyKey)) {
      try {
        const prior = read(contextKey);
        const profileFitPreference = brand === 'cz' && profile.measurementSource === 'profile' ? profile.fitPreference : prior?.profileFitPreference;
        localStorage.setItem(contextKey, JSON.stringify({ source: profile.measurementSource || 'body', productId: String(this.config.product.id), version: 1, profileFitPreference }));
      } catch {}
    }
    document.dispatchEvent(new CustomEvent(eventName, { detail: { source: this } }));
    return value;
  };
  const forget = proto.forgetMemory;
  proto.forgetMemory = function(...args) {
    this.smartConfirmed = null;
    try { localStorage.removeItem(contextKey); } catch {}
    const value = forget.apply(this, args);
    this.refreshSizeGuideLink();
    document.dispatchEvent(new CustomEvent(eventName, { detail: { source: this } }));
    return value;
  };
  const variant = proto.onVariant;
  proto.onVariant = function(...args) {
    const value = variant.apply(this, args);
    this.refreshSizeGuideLink();
    return value;
  };
  const disconnect = proto.disconnectedCallback;
  proto.disconnectedCallback = function(...args) {
    this.smartObserver?.disconnect(); this.smartAbort?.abort(); this.smartOwner = null; this.smartButton = null;
    return disconnect.apply(this, args);
  };
}

if (!customElements.get('ac-size-suggestion')) {
  const acSizeEngine = createACSizeEngine();
  class ACSizeSuggestion extends HTMLElement {
    static get observedAttributes() { return ['data-ac-config']; }

    text(key, fallback = '') { return typeof this.copy?.[key] === 'string' && this.copy[key].trim() ? this.copy[key] : fallback; }

    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('change', (event) => this.onChange(event), { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.matches('input[type="number"]')) {
          event.preventDefault();
          this.calculate(true);
        }
      }, { signal });
      document.addEventListener('variant:update', (event) => this.onVariant(event), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        if (event.detail?.blockId === this.dataset.blockId) this.closest('dialog-component')?.showDialog?.();
      }, { signal });
      this.observer = new MutationObserver((changes) => {
        if (changes.some((change) => [...change.addedNodes].some((node) => node.nodeType === 1 && (node.matches('[data-ac-ui]') || node.querySelector('[data-ac-ui]'))))) {
          this.queueInit();
        }
      });
      this.observer.observe(this, { childList: true });
      this.queueInit();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }

    attributeChangedCallback(name, before, after) {
      if (before !== after && this.isConnected) this.queueInit();
    }

    queueInit() {
      if (this.initQueued) return;
      this.initQueued = true;
      queueMicrotask(() => {
        this.initQueued = false;
        if (this.isConnected) this.init();
      });
    }

    init() {
      if (!this.querySelector('[data-ac-ui]')) return;
      try { this.config = JSON.parse(this.dataset.acConfig); } catch { return; }
      this.copy = this.config.copy;
      this.analysis = acSizeEngine.analyse(this.config.product, this.config.settings);
      this.unit = this.config.unit;
      this.lastResult = null;
      this.lastProfile = null;
      const saved = this.readMemory();
      if (saved) {
        this.unit = saved.unit === 'imperial' ? 'imperial' : 'metric';
        this.setProfile(saved);
      }
      this.setUnits(this.unit, false);
      this.querySelector('[data-ac-forget]').hidden = !saved;
      this.querySelector('[data-ac-result]').hidden = true;
      this.querySelector('[data-ac-entry]').hidden = false;
      this.querySelector('[data-ac-error]').hidden = true;
      this.refreshCategory();
      this.renderChart();
      if (saved && this.analysis.supported) this.calculate(false);
    }

    readMemory() {
      try {
        const value = JSON.parse(localStorage.getItem('ac_size_profile_v1'));
        if (value?.version !== 1 || !Number.isFinite(value.heightCm) || !Number.isFinite(value.weightKg)) return null;
        if (value.heightCm < 120 || value.heightCm > 230 || value.weightKg < 30 || value.weightKg > 250) return null;
        return value;
      } catch { return null; }
    }

    saveMemory(profile) {
      if (!this.querySelector('[data-ac-remember]').checked) {
        this.forgetMemory(false);
        return;
      }
      try {
        localStorage.setItem('ac_size_profile_v1', JSON.stringify({ ...profile, unit: this.unit, version: 1 }));
        this.querySelector('[data-ac-forget]').hidden = false;
      } catch {}
    }

    forgetMemory(clear = true) {
      try { localStorage.removeItem('ac_size_profile_v1'); } catch {}
      this.querySelector('[data-ac-forget]').hidden = true;
      if (clear) {
        this.lastProfile = null;
        this.lastResult = null;
        this.querySelectorAll('input[type="number"]').forEach((input) => { input.value = ''; });
        this.querySelector('[data-ac-fit]').value = 'intended';
        this.showEntry();
      }
    }

    value(name) {
      const input = this.querySelector(`[data-ac-input="${name}"]`);
      if (!input || input.value.trim() === '') return null;
      const value = Number(input.value);
      return Number.isFinite(value) ? value : NaN;
    }

    profile() {
      const metric = this.unit === 'metric';
      const feet = this.value('ft');
      const inches = this.value('in');
      const height = metric ? this.value('cm') : feet === null && inches === null ? null : ((feet || 0) * 12 + (inches || 0)) * 2.54;
      const weight = metric ? this.value('kg') : this.value('lbs') === null ? null : this.value('lbs') * 0.45359237;
      const bodyFactor = metric ? 1 : 2.54;
      const waist = this.value('waist');
      const chest = this.value('chest');
      return {
        heightCm: height,
        weightKg: weight,
        waistCm: waist === null ? null : waist * bodyFactor,
        chestCm: chest === null ? null : chest * bodyFactor,
        fitPreference: this.querySelector('[data-ac-fit]').value
      };
    }

    setProfile(profile) {
      const set = (name, value) => {
        this.querySelector(`[data-ac-input="${name}"]`).value = Number.isFinite(value) ? String(Math.round(value * 10) / 10) : '';
      };
      set('cm', profile.heightCm);
      set('kg', profile.weightKg);
      const totalInches = Number.isFinite(profile.heightCm) ? Math.round(profile.heightCm / 2.54 * 10) / 10 : null;
      set('ft', totalInches === null ? null : Math.floor(totalInches / 12));
      set('in', totalInches === null ? null : Math.round((totalInches % 12) * 10) / 10);
      set('lbs', Number.isFinite(profile.weightKg) ? profile.weightKg / 0.45359237 : null);
      const factor = this.unit === 'metric' ? 1 : 1 / 2.54;
      set('waist', Number.isFinite(profile.waistCm) ? profile.waistCm * factor : null);
      set('chest', Number.isFinite(profile.chestCm) ? profile.chestCm * factor : null);
      this.querySelector('[data-ac-fit]').value = profile.fitPreference === 'relaxed' ? 'relaxed' : 'intended';
    }

    setUnits(unit, convert = true) {
      const oldProfile = convert ? this.profile() : null;
      this.unit = unit;
      if (oldProfile) this.setProfile(oldProfile);
      this.querySelectorAll('[data-ac-unit]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.acUnit === unit)));
      this.querySelectorAll('[data-ac-units]').forEach((group) => {
        const hidden = group.dataset.acUnits !== unit;
        group.hidden = hidden;
        group.querySelectorAll('input').forEach((input) => { input.disabled = hidden; });
      });
      this.querySelectorAll('[data-ac-body-unit]').forEach((label) => { label.textContent = unit === 'metric' ? 'cm' : 'in'; });
      for (const name of ['waist', 'chest']) {
        const field = this.querySelector(`[data-ac-input="${name}"]`);
        field.min = unit === 'metric' ? '40' : '15.7';
        field.max = unit === 'metric' ? '200' : '78.7';
        field.placeholder = unit === 'metric' ? (name === 'waist' ? '80' : '96') : (name === 'waist' ? '31.5' : '38');
      }
      this.renderChart();
    }

    refreshCategory() {
      const category = this.analysis.category;
      const bottom = category === 'bottoms';
      this.querySelector('[data-ac-category]').textContent = this.copy[`category_${category}`] || this.copy.category_tops;
      this.querySelector('[data-ac-waist-group]').hidden = !bottom;
      this.querySelector('[data-ac-chest-group]').hidden = bottom;
      this.querySelector('[data-ac-input="waist"]').disabled = !bottom;
      this.querySelector('[data-ac-input="chest"]').disabled = bottom;
      this.querySelector('[data-ac-help]').textContent = bottom ? this.copy.waist_help : this.copy.chest_help;
      const unsupported = !this.analysis.supported;
      this.querySelector('[data-ac-entry]').hidden = unsupported;
      this.querySelector('[data-ac-unavailable]').hidden = !unsupported;
      this.querySelector('[data-ac-unavailable]').textContent = this.config.product.id ? this.copy.unsupported : this.copy.preview;
    }

    onClick(event) {
      const control = event.target.closest('button');
      if (!control || !this.contains(control)) return;
      if (control.dataset.acUnit) this.setUnits(control.dataset.acUnit);
      if (control.hasAttribute('data-ac-calculate')) this.calculate(true);
      if (control.hasAttribute('data-ac-edit')) this.showEntry();
      if (control.hasAttribute('data-ac-forget')) this.forgetMemory();
    }

    onChange(event) {
      if (event.target.matches('[data-ac-remember]') && !event.target.checked) this.forgetMemory(false);
    }

    onVariant(event) {
      const section = this.closest('.shopify-section');
      if (section && !section.contains(event.target)) return;
      if (!this.config) return;
      const resource = event.detail?.resource;
      const variant = (this.config.product.variants || []).find((item) => String(item.id) === String(resource?.id));
      if (!variant) return;
      this.config.product.selectedOptions = variant.options;
      this.analysis = acSizeEngine.analyse(this.config.product, this.config.settings);
      this.renderChart();
      if (this.lastProfile && !this.querySelector('[data-ac-result]').hidden) this.renderResult(acSizeEngine.recommend(this.analysis, this.lastProfile), false);
    }

    showEntry() {
      this.querySelector('[data-ac-result]').hidden = true;
      this.querySelector('[data-ac-entry]').hidden = !this.analysis.supported;
      this.querySelector('[data-ac-error]').hidden = true;
      if (this.analysis.supported) this.querySelector(`[data-ac-input="${this.unit === 'metric' ? 'cm' : 'ft'}"]`).focus({ preventScroll: true });
    }

    calculate(interactive) {
      if (!this.analysis.supported) return;
      const profile = this.profile();
      let error = null;
      if (!Number.isFinite(profile.heightCm) || profile.heightCm < 120 || profile.heightCm > 230) error = 'height_error';
      else if (this.unit === 'imperial' && (this.value('in') < 0 || this.value('in') >= 12 || this.value('ft') < 0 || !Number.isInteger(this.value('ft')))) error = 'height_error';
      else if (!Number.isFinite(profile.weightKg) || profile.weightKg < 30 || profile.weightKg > 250) error = 'weight_error';
      else {
        const measure = this.analysis.category === 'bottoms' ? profile.waistCm : profile.chestCm;
        if (measure !== null && (!Number.isFinite(measure) || measure < 40 || measure > 200)) error = 'body_error';
      }
      const errorNode = this.querySelector('[data-ac-error]');
      errorNode.hidden = !error;
      if (error) {
        if (interactive) { errorNode.textContent = this.copy[error]; errorNode.focus({ preventScroll: true }); }
        return;
      }
      this.lastProfile = profile;
      if (interactive) this.saveMemory(profile);
      const result = acSizeEngine.recommend(this.analysis, profile);
      this.renderResult(result, interactive);
    }

    renderResult(result, focus) {
      this.lastResult = result;
      const ok = result.status === 'ok';
      const conditional = ok && result.conditional === true;
      const chartMismatch = !ok && [...(result.notes || []), ...(this.analysis.chartIssues || [])].some(key => ['size_label_mismatch', 'incomplete_chart'].includes(key));
      const resultNode = this.querySelector('[data-ac-result]');
      this.querySelector('[data-ac-entry]').hidden = true;
      resultNode.hidden = false;
      this.querySelector('[data-ac-result-label]').textContent = conditional ? this.text('conditional_heading', 'Closest size to compare') : chartMismatch ? this.text('chart_mismatch_heading', 'Check the product size chart') : ok ? this.copy.recommendation : this.copy.check_fit;
      const size = this.querySelector('[data-ac-size]');
      size.textContent = ok ? result.size : chartMismatch ? this.text('chart_mismatch_size', 'No reliable size match') : this.copy.no_size;
      size.classList.toggle('ac-sg__size--message', !ok);
      const inferred = result.notes?.includes('inferred_flat_measurement');
      const profileChart = result.notes?.includes('profile_chart_estimate');
      const waistAdvice = result.notes?.some(key => ['waist_close_fit', 'waist_roomier_fit'].includes(key));
      const waistCheck = result.notes?.some(key => ['profile_waist_position', 'hips_unverified'].includes(key));
      this.querySelector('[data-ac-method]').textContent = conditional ? this.text('method_conditional', 'This is the closest measured option, not a confirmed fit. Compare it with a fitted top you already wear.') : chartMismatch ? this.text('chart_mismatch_help', 'The published measurements could not be matched reliably to the available sizes. Compare the chart and size selector before choosing.') : !ok ? (result.status === 'need_measurement' ? this.copy.need_measurement : this.copy.no_match) : profileChart ? this.text('method_profile_chart', 'Estimated from your height, weight and this product’s measurements.') : inferred ? this.copy.method_inferred : result.method === 'measurements' ? this.copy.method_measurements : this.copy.method_estimate;
      const notes = this.querySelector('[data-ac-notes]');
      notes.replaceChildren();
      const messages = [];
      if (ok && !conditional && result.method !== 'measurements' && !inferred && !result.notes?.includes('body_measurement_not_used') && !(this.analysis.category === 'bottoms' && (waistAdvice || waistCheck))) messages.push(this.analysis.category === 'bottoms' ? this.copy.estimate_waist : this.copy.estimate_chest);
      if (result.notes?.includes('body_measurement_not_used')) messages.push(this.copy.body_not_used);
      if (result.notes?.includes('check_length')) messages.push(this.copy.length_note);
      if (result.notes?.includes('range_uses_minimum')) messages.push(this.copy.range_note);
      if (ok) {
        if (result.notes?.includes('fitted_comparison')) messages.push(this.text('fitted_comparison', 'This size is narrower than the chest estimate from your height and weight. Fabric stretch is not specified, so check a similar fitted top before choosing.'));
        if (result.notes?.includes('size_label_mismatch')) messages.push(this.text('size_label_mismatch', 'Some size labels differ between the chart and the selector. Only exact matching labels were compared; confirm the label before ordering.'));
        if (result.notes?.some(key => ['inferred_flat_measurement', 'inferred_hip_measurement'].includes(key))) messages.push(this.text('flat_measurement_note', 'Some chart values appear to be flat widths. The estimate accounts for this; compare them with a similar garment to confirm.'));
        if (result.notes?.includes('incomplete_chart') && !result.notes?.includes('size_label_mismatch')) messages.push(this.text('partial_chart_note', 'Only sizes with published measurements were compared.'));
        const fitNotes = {
          waist_close_fit: 'This size may fit snug at the waist. Check the waist measurement before choosing.',
          waist_roomier_fit: 'This size may sit looser at the waist. Compare the waist measurement with a pair that fits you well.',
          closer_fit: 'This size may fit closer to your body. Compare the measurements with a similar garment that fits you well.',
          roomier_fit: 'This size may fit roomier. Compare the measurements with a similar garment that fits you well.',
          closest_available_chart_size: 'This is the closest option in this product’s size chart.'
        };
        for (const key of result.notes || []) if (!conditional && fitNotes[key]) messages.push(this.text(key, fitNotes[key]));
        if (waistCheck && !waistAdvice) messages.push(this.text('profile_waist_note', 'Check your actual waist and hips for a closer comparison.'));
        else if (waistAdvice && result.notes?.includes('hips_unverified')) messages.push(this.text('profile_hip_note', 'Check your hips against the product measurements too.'));
      }
      if (this.analysis.fit === 'slim') messages.push(this.copy.slim_note);
      if (this.analysis.cropped) messages.push(this.copy.cropped_note);
      if (ok && result.available === false) messages.push(this.copy.stock_note);
      if (ok && this.analysis.category === 'bottoms' && result.method === 'measurements') messages.push(this.copy.waist_note);
      for (const message of [...new Set(messages)].filter(Boolean)) {
        const item = document.createElement('li');
        item.textContent = message;
        notes.append(item);
      }
      notes.hidden = notes.childElementCount === 0;
      if (focus) resultNode.focus({ preventScroll: true });
    }

    chartDisplay(table, context) {
      const rows = [...table.rows].filter(row => row.closest('table') === table).map(row => [...row.cells]);
      const values = new Map();
      const dimension = text => {
        if (/^\s*(?:sizes?\b|taglia\b|taille\b|talla\b|EU\b|US\b|UK\b|尺码)/i.test(text)) return null;
        if (/\bweight\b/i.test(text)) return 'weight';
        return /\b(chest|bust|waist|hips?|seat|shoulders?|sleeves?|length|lenght|height|width|depth|inseam|outseam|rise|thigh|hem|cuff|opening|circumference|girth|pit[ -]to[ -]pit|petto|vita|spalle|manica|lunghezza)\b/i.test(text) ? 'length' : null;
      };
      const unitPattern = /\b(?:centimet(?:er|re)s?|millimet(?:er|re)s?|inches|inch|cm|mm|kilograms?|pounds?|kg|lbs?)\b|\bin\b(?=\s*(?:[)\]]|$))|[″"]/gi;
      const unitOf = (text, kind) => {
        const units = (text.match(unitPattern) || []).map(value => {
          const word = value.toLowerCase();
          if (/^(cm|centimet)/.test(word)) return 'cm';
          if (/^(mm|millimet)/.test(word)) return 'mm';
          if (/^(kg|kilogram)/.test(word)) return 'kg';
          if (/^(lb|pound)/.test(word)) return 'lb';
          return 'in';
        }).filter(unit => kind === 'weight' ? ['kg', 'lb'].includes(unit) : ['cm', 'mm', 'in'].includes(unit));
        return [...new Set(units)].length === 1 ? units[0] : null;
      };
      const targetUnit = kind => kind === 'weight' ? this.unit === 'imperial' ? 'lb' : 'kg' : this.unit === 'imperial' ? 'in' : 'cm';
      const factor = { cm: 1, mm: 0.1, in: 2.54, kg: 1, lb: 0.45359237 };
      const convert = (text, kind, sourceUnit) => {
        const original = text.trim();
        if (!original || /^(?:[-–—]|n\/?a)$/i.test(original)) return original;
        const raw = original.replace(/,/g, '.').replace(/[–—~～]/g, '-');
        const match = raw.match(/^(\d+(?:\.\d+)?)\s*(mm|cm|inches|inch|in|[″"]|kg|lbs?|kilograms?|pounds?)?\s*(?:([-\/])\s*(\d+(?:\.\d+)?)\s*(mm|cm|inches|inch|in|[″"]|kg|lbs?|kilograms?|pounds?)?)?$/i);
        if (!match) return null;
        const explicit = unitOf([match[2], match[5]].filter(Boolean).join(' '), kind);
        if ((match[2] || match[5]) && !explicit) return null;
        const unit = explicit || sourceUnit;
        const scale = factor[unit] / factor[targetUnit(kind)];
        const number = value => String(Math.round(Number(value) * scale * 10) / 10);
        return number(match[1]) + (match[4] ? (match[3] === '/' ? ' / ' : '–') + number(match[4]) : '');
      };
      let changed = false;
      const applyAxis = (head, cells) => {
        const kind = dimension(head.textContent);
        if (!kind || !cells.length || head.colSpan > 1 || head.rowSpan > 1) return;
        const firstRowUnit = unitOf((rows[0] || []).map(cell => cell.textContent.trim()).join(' · '), kind);
        const contextUnit = /measure|size\s*(chart|guide)|units?|^\s*\(?\s*(cm|mm|in|inches|inch|kg|lbs?)\s*\)?\s*$/i.test(context) ? unitOf(context, kind) : null;
        const sourceUnit = unitOf(head.textContent, kind) || firstRowUnit || contextUnit || (kind === 'weight' ? 'kg' : 'cm');
        const converted = cells.map(cell => cell.colSpan === 1 && cell.rowSpan === 1 ? convert(cell.textContent, kind, sourceUnit) : null);
        if (converted.some(value => value === null)) return;
        const label = head.textContent.trim().replace(unitPattern, '').replace(/\(\s*\)|\[\s*\]/g, '').replace(/\bin\s*$/i, '').replace(/\s+/g, ' ').trim();
        values.set(head, `${label} (${targetUnit(kind)})`);
        cells.forEach((cell, index) => values.set(cell, converted[index]));
        changed = true;
      };
      const first = rows[0] || [];
      const horizontal = first.some(cell => dimension(cell.textContent));
      if (horizontal && first.every(cell => cell.colSpan === 1 && cell.rowSpan === 1) && rows.length > 1) {
        first.forEach((head, column) => applyAxis(head, rows.slice(1).map(row => row[column]).filter(Boolean)));
      } else {
        for (const row of rows) if (row.length > 1) applyAxis(row[0], row.slice(1));
      }
      if (changed) for (const row of rows) for (const cell of row) {
        if (/^\s*sizes?\b/i.test(cell.textContent)) values.set(cell, cell.textContent.trim().replace(/\(\s*(?:cm|mm|inches|inch|in)\s*\)/gi, '').trim());
      }
      const caption = changed && !/\d/.test(context) ? context.replace(/\b(?:centimet(?:er|re)s?|millimet(?:er|re)s?|inches|inch|cm|mm)\b|\bin\b(?=\s*\))/gi, targetUnit('length')) : context;
      return { values, caption };
    }

    renderChart() {
      const host = this.querySelector('[data-ac-chart]');
      const details = this.querySelector('[data-ac-details]');
      if (!host || !details || !this.config?.product) return;
      // Keep the original measurements isolated from legacy page-wide unit toggles.
      const shadow = host.shadowRoot || host.attachShadow({ mode: 'open' });
      shadow.replaceChildren();
      const parsed = new DOMParser().parseFromString(this.config.product.description || '', 'text/html');
      const tables = [...parsed.querySelectorAll('table')].filter(table => !table.parentElement?.closest('table'));
      const relevant = tables.filter(table => {
        const tableText = [...table.querySelectorAll('th,td')].map(cell => cell.textContent.trim()).join(' ');
        const hasSize = /\b(size|sizes|taglia|taille|talla|EU|US|UK)\b|尺码/i.test(tableText);
        const hasMeasure = /\b(chest|waist|bust|hip|length|height|weight|foot|insole|petto|vita|shoulder|sleeve|cm|kg|lbs)\b/i.test(tableText);
        const fragment = table.rows.length === 1 && /^(size|sizes|chest|waist|bust|hip|length|lenght|shoulder|sleeve)\b/i.test(table.rows[0].cells[0]?.textContent.trim() || '') && table.rows[0].cells.length > 1;
        return (hasSize && hasMeasure) || fragment;
      });
      details.hidden = !relevant.length;
      if (details.hidden) return;
      const style = document.createElement('style');
      style.textContent = ':host{display:block;max-width:100%;font:inherit;color:inherit}.scroll{max-width:100%;overflow:auto}table{border-collapse:collapse;font-size:11px;line-height:1.4;width:100%;white-space:nowrap;margin:0 0 14px}td,th{padding:8px 10px;border:1px solid #ddd;text-align:center}th{background:#f6f6f6;font-weight:600}caption{padding:7px 0;text-align:left;font-weight:600;white-space:normal}';
      shadow.append(style);
      const tableContexts = new Map();
      for (const [index, table] of relevant.entries()) {
        const wrap = document.createElement('div');
        wrap.className = 'scroll'; wrap.tabIndex = 0; wrap.setAttribute('role', 'region'); wrap.setAttribute('aria-label', this.text('chart', 'Product measurements') + (relevant.length > 1 ? ` ${index + 1}` : ''));
        const cleanTable = document.createElement('table');
        let previous = table.previousElementSibling;
        while (previous && (previous.tagName === 'BR' || !previous.textContent.trim())) previous = previous.previousElementSibling;
        const context = previous?.matches('table') ? tableContexts.get(previous) || '' : previous && !previous.querySelector('table,img') && previous.textContent.trim().length <= 180 ? previous.textContent.trim() : '';
        tableContexts.set(table, table.caption?.textContent.trim() || context);
        const display = this.chartDisplay(table, table.caption?.textContent.trim() || context);
        const isSelected = relevant.length > 1 && Number.isInteger(this.analysis?.chart?.index) && [...parsed.querySelectorAll('table')].indexOf(table) === this.analysis.chart.index;
        if (isSelected) cleanTable.setAttribute('data-ac-active-chart', '');
        let captionText = display.caption || (relevant.length > 1 ? this.text('chart', 'Product measurements') + ` ${index + 1}` : '');
        if (isSelected) captionText += (captionText ? ' · ' : '') + this.text('selected_chart', 'Measurements for the selected product options');
        if (captionText) { const caption = document.createElement('caption'); caption.textContent = captionText; cleanTable.append(caption); }
        for (const [rowIndex, row] of [...table.rows].filter(row => row.closest('table') === table).entries()) {
          const cleanRow = document.createElement('tr');
          for (const cell of row.cells) {
            const cleanCell = document.createElement(cell.tagName === 'TH' || rowIndex === 0 ? 'th' : 'td');
            cleanCell.textContent = display.values.get(cell) ?? cell.textContent.trim();
            if (cell.colSpan > 1 && cell.colSpan <= 30) cleanCell.colSpan = cell.colSpan;
            if (cell.rowSpan > 1 && cell.rowSpan <= 100) cleanCell.rowSpan = cell.rowSpan;
            cleanRow.append(cleanCell);
          }
          cleanTable.append(cleanRow);
        }
        wrap.append(cleanTable); shadow.append(wrap);
      }
    }
  }
  enhanceSizeGuide(ACSizeSuggestion, acSizeEngine, 'ac');
  customElements.define('ac-size-suggestion', ACSizeSuggestion);
}
  } catch(e) { console.error(e); }
})();

})();
